module.exports = __webpack_public_path__ + "static/img/ccrs-xq.6e98a05.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ccrs-xq.png
// module id = 5PeE
// module chunks = 0